// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"96c1c06d","455":"7a6145ab","977":"3f093636"}[chunkId] + ".chunk.js";
};